import './common.css';

// Transparent gray overlay for popups/modals

function Overlay({ onClose, darkBackground, style, children }) {

    return(
        <div>
            <div
                className="OverlayBackdrop"
                onClick={onClose}
                style={{
                    background: darkBackground ? 'rgba(0, 0, 0, 0.4)' : 'transparent'
                }}
            />
            <div
                className="Overlay"
                style={style}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    )

}

export default Overlay;